export function decodeJwtPayload<T = Record<string, any>>(
  token?: string | null
): T | null {
  const payload = token?.split('.')[1]
  if (!payload) return null

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    )
    const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0))
    return JSON.parse(new TextDecoder('utf-8').decode(bytes)) as T
  } catch (error) {
    console.error('Erro ao decodificar token:', error)
    return null
  }
}
